import React from 'react'
import { Icon } from 'semantic-ui-react'
import { ResponsiveImage } from '@iheartjane/react-responsive-image'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

const productSrcWidths = [100, 200, 400, 800, 1000]

export const SortablePhoto = ({ url, removeImage }: any) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: url })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: '30%',
    maxHeight: 200,
    paddingRight: 10,
    paddingBottom: 10,
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <ResponsiveImage
        className="ui bordered image"
        style={{ borderRadius: '5px', pointerEvents: 'none' }}
        src={url}
        srcWidths={productSrcWidths}
        fallbackWidth={200}
        alt=""
      />
      <a href={url} target="_blank" rel="noopener noreferrer">
        View Source
      </a>
      <Icon name="trash alternate outline" link onClick={() => removeImage(url)} />
    </div>
  )
}
